import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import Router from "vue-router";
import jwt from "jsonwebtoken";
import { getRefreshToken, hasRole } from "@/js/http/auth.js";

//PROFILES
import ProfileDefault from "./views/profiles/DefaultProfile.vue";
import ProfileDefaultV2 from "./views/profiles/DefaultProfileV2.vue";
import ProfileUser from "./views/profiles/UserProfile.vue";
import ProfileFirstConnection from "./views/profiles/FirstConnectionProfile.vue";

//COMMON LOGGED PAGES
import FinalizeCart from "./views/logged/FinalizeCart.vue";
import ExportPriceList from "./views/logged/ExportPriceList.vue";

//DEFAULT
import AcceptTerms from "./views/default/AcceptTerms.vue";
import Subscribe from "./views/default/Subscribe.vue";
import ResetPassword from "./views/default/ResetPassword.vue";
import ActionReset from "./views/default/ActionReset.vue";
import Login from "./views/default/Login.vue";
import Consent from "./views/default/Consent.vue";
import Contact from "./views/default/Contact.vue";
import Home from "./views/default/Home.vue";
import Event from "./views/default/Event.vue";
import StartScreen from "./views/default/StartScreen.vue";
import OrderOneClickAction from "./views/default/OrderOneClickAction.vue";
import InboundOneClickAction from "./views/default/InboundOneClickAction.vue";
import TermsOfSales from "./views/default/TermsOfSales.vue";
import TermsOfUse from "./views/default/TermsOfUse.vue";
import PublicWineryDashboard from "./views/default/PublicWineryDashboard.vue";
import CellarJournal from "./views/default/CellarJournal.vue";
import CellarJournalDetail from "./views/default/CellarJournalDetail.vue";

//USER
import UserHome from "./views/user/Home.vue";
import UserProfile from "./views/user/Profile.vue";
import UserCellar from "./views/user/Cellar.vue";
import UserCellarWineDetails from "./views/user/CellarWineDetails.vue";
import UserContact from "./views/user/Contact.vue";
import UserConciergerie from "./views/user/Conciergerie.vue";
import UserProductList from "./views/user/ProductList.vue";
import UserWineDetails from "./views/user/WineDetails.vue";
import UserSpiritDetails from "./views/user/SpiritDetails.vue";
import UserOrderSummary from "./views/user/OrderDetails.vue";
import UserPayment from "./views/user/Payment.vue";
import UserRegionList from "./views/user/RegionList.vue";
import UserRegionDetails from "./views/user/RegionDetails.vue";
import UserProducerDetails from "./views/user/ProducerDetails.vue";
import UserTastingPhotos from "./views/user/TastingPhotos.vue";

//ADMINISTRATION
import AdminUserList from "./views/admin/UserList.vue";
import AdminUserRoles from "./views/admin/UserRoles.vue";
import AdminUserDetails from "./views/admin/UserDetails.vue";
import AdminStockList from "./views/admin/StockList.vue";
import AdminPurchaseOrder from "./views/admin/PurchaseOrder.vue";
import AdminStockDetails from "./views/admin/StockDetails.vue";
import AdminProductList from "./views/admin/ProductList.vue";
import AdminWineDetails from "./views/admin/WineDetails.vue";
import AdminSpiritDetails from "./views/admin/SpiritDetails.vue";
import AdminRegionList from "./views/admin/RegionList.vue";
import AdminRegionDetails from "./views/admin/RegionDetails.vue";
import AdminProducerList from "./views/admin/ProducerList.vue";
import AdminProducerDetails from "./views/admin/ProducerDetails.vue";
import AdminCommissionList from "./views/admin/CommissionList.vue";
import ConsultantCommissionList from "./views/admin/ConsultantCommissionList.vue";
import AdminOrders from "./views/admin/Orders.vue";
import AdminOrderSummary from "./views/admin/OrderDetails.vue";
import ConsultantOrderDetails from "./views/admin/ConsultantOrderDetails.vue";
import AdminCreditNote from "./views/admin/CreditNote.vue";
import AdminListContact from "./views/admin/ContactList.vue";
import AdminShipping from "./views/admin/Shipping.vue";
import AdminListIndicators from "./views/admin/IndicatorsList.vue";
import AdminSettings from "./views/admin/Settings.vue";
import DeveloperTools from "./views/admin/DeveloperTools.vue";
import AdminInboundDeliveryDetails from "./views/admin/InboundDeliveryDetails.vue";
import AdminTastingPhotos from "./views/admin/TastingPhotos.vue";
import AdminEventDetails from "./views/admin/EventDetails.vue";
import AdminEventList from "./views/admin/EventList.vue";
//ERROR
import Error from "./views/error/error.vue";

//MAINTENANCE
import MaintenancePage from "./views/maintenance/MaintenancePage.vue";
import { handleNewsletter } from "@/js/middleware";
export var orderPaths = {
  finalizeCart: "/cart",
  payment: "/order/payment"
};
var metaDatas = {
  title: ""
};
var requireTokenExpiration = true;
var routes = {
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
    path: "/",
    meta: metaDatas,
    name: "start",
    component: ProfileDefaultV2,
    children: [{
      path: "/",
      name: "home",
      meta: metaDatas,
      component: Home
    }]
  }, {
    path: "*",
    component: Error,
    props: {
      error: {
        link: "userHome",
        linkTitle: "home"
      }
    }
  }, {
    path: "/homeV2",
    meta: metaDatas,
    name: "defaultV2",
    component: ProfileDefaultV2,
    children: [{
      path: "/home",
      name: "home",
      meta: metaDatas,
      component: Home
    }, {
      path: "/login",
      meta: metaDatas,
      name: "login",
      component: Login
    }, {
      path: "/subscribe",
      meta: metaDatas,
      name: "subscribe",
      component: Subscribe
    }, {
      path: "/reset",
      meta: metaDatas,
      name: "reset",
      component: ResetPassword
    }, {
      path: "/terms-of-sales",
      meta: metaDatas,
      name: "termsOfSales",
      component: TermsOfSales
    }, {
      path: "/terms-of-use",
      meta: metaDatas,
      name: "termsOfUse",
      component: TermsOfUse
    }, {
      path: "/contact",
      meta: metaDatas,
      name: "contact",
      component: Contact
    }, {
      path: "/cellar-journal",
      meta: metaDatas,
      name: "cellarJournal",
      component: CellarJournal
    }, {
      path: "/cellar-journal/:slug",
      meta: metaDatas,
      name: "cellarJournalDetail",
      component: CellarJournalDetail,
      props: true
    }, {
      path: "/events/:eventUrl",
      meta: metaDatas,
      name: "defaultEvent",
      component: Event,
      props: true
    }]
  }, {
    path: "/home",
    meta: metaDatas,
    name: "default",
    component: ProfileDefault,
    children: [{
      path: "/consent",
      meta: metaDatas,
      name: "consent",
      component: Consent
    }, {
      path: "/reset/:key",
      meta: metaDatas,
      name: "action-reset",
      component: ActionReset
    }, {
      path: "/one-click-action/order/:guid",
      meta: {
        metaDatas: metaDatas
      },
      name: "oneClickActionOrder",
      component: OrderOneClickAction
    }, {
      path: "/one-click-action/inbound/:guid",
      meta: {
        metaDatas: metaDatas
      },
      name: "oneClickActionInbound",
      component: InboundOneClickAction
    }, {
      path: "/accept-terms",
      name: "accept-terms",
      meta: metaDatas,
      component: AcceptTerms
    }, {
      path: "/my-dashboard/:guid",
      meta: {
        metaDatas: metaDatas
      },
      name: "PublicWineryDashboard",
      component: PublicWineryDashboard
    }, {
      path: "*",
      component: Error,
      props: {
        error: {
          link: "userHome",
          linkTitle: "home"
        }
      }
    }]
  }, {
    path: "/edit-account",
    meta: metaDatas,
    component: ProfileFirstConnection,
    children: [{
      path: "/",
      meta: metaDatas,
      name: "firstConnectionProfile",
      component: UserProfile,
      props: {
        firstConnection: true
      }
    }]
  }, {
    path: "/user/home",
    meta: {
      metaDatas: metaDatas,
      requireTokenExpiration: requireTokenExpiration
    },
    name: "userHome",
    component: UserHome
  }, {
    path: "/user/",
    meta: {
      metaDatas: metaDatas,
      requireTokenExpiration: requireTokenExpiration
    },
    component: ProfileUser,
    children: [
    // COMMON LOGGED PAGES
    {
      path: orderPaths.finalizeCart,
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "finalizeCart",
      component: FinalizeCart
    }, {
      path: "/user/export-price-list",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "exportPriceList",
      component: ExportPriceList
    },
    // USER PAGES
    {
      path: "/user/cellar",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userCellar",
      component: UserCellar
    }, {
      path: "/user/cellar/wine",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userCellarWineDetails",
      component: UserCellarWineDetails
    }, {
      path: "/user/profile",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userProfile",
      component: UserProfile,
      props: {
        firstConnection: false
      }
    }, {
      path: "/user/contact",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userContact",
      component: UserContact
    }, {
      path: "/user/conciergerie",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userConciergerie",
      component: UserConciergerie
    }, {
      path: "/user/products",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userProductList",
      component: UserProductList,
      params: {
        producer: null,
        return: null
      }
    }, {
      path: "/user/wine/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userWineDetails",
      component: UserWineDetails
    }, {
      path: "/user/spirits/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userSpiritsDetails",
      component: UserSpiritDetails
    }, {
      path: "/user/orders/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userOrderSummary",
      component: UserOrderSummary
    }, {
      path: "/user/profile",
      meta: {
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userOrderList",
      component: UserProfile
    }, {
      path: orderPaths.payment,
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "orderPayment",
      component: UserPayment
    }, {
      path: "/user/regions",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userRegionList",
      component: UserRegionList
    }, {
      path: "/user/region",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userRegionDetails",
      component: UserRegionDetails
    }, {
      path: "/user/producers/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userProducerDetails",
      component: UserProducerDetails
    }, {
      path: "/user/terms-of-sales",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userTermsOfSales",
      component: TermsOfSales
    }, {
      path: "/user/terms-of-use",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userTermsOfUse",
      component: TermsOfUse
    }, {
      path: "/user/tasting-photos",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "userTastingPhotos",
      component: UserTastingPhotos
    },
    // ADMIN PAGES
    {
      path: "/admin/users",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminUserList",
      component: AdminUserList
    }, {
      path: "/admin/user/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminUserDetails",
      component: AdminUserDetails
    }, {
      path: "/admin/user/roles",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminUserRoles",
      component: AdminUserRoles
    }, {
      path: "/admin/stocks",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminStockList",
      component: AdminStockList
    }, {
      path: "/admin/stock/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminStockDetails",
      component: AdminStockDetails
    }, {
      path: "/admin/stocks/purchase-orders",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminNewPurchaseOrder",
      component: AdminPurchaseOrder
    }, {
      path: "/admin/stocks/purchase-orders/:id",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminEditPurchaseOrder",
      component: AdminPurchaseOrder
    }, {
      path: "/admin/products",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminProductList",
      component: AdminProductList
    }, {
      path: "/admin/wines/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminWineDetails",
      component: AdminWineDetails
    }, {
      path: "/admin/spirits/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminSpiritsDetails",
      component: AdminSpiritDetails
    }, {
      path: "/admin/regions",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminRegionList",
      component: AdminRegionList
    }, {
      path: "/admin/region",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminRegionDetails",
      component: AdminRegionDetails
    }, {
      path: "/admin/producers",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminProducerList",
      component: AdminProducerList
    }, {
      path: "/admin/producers/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminProducerDetails",
      component: AdminProducerDetails
    }, {
      path: "/admin/commission/list",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminCommissionList",
      component: AdminCommissionList
    }, {
      path: "/admin/orders",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminOrderList",
      component: AdminOrders
    }, {
      path: "/admin/orders/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminOrderSummary",
      component: AdminOrderSummary
    }, {
      path: "/consultant/orders/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "consultantOrderDetails",
      component: ConsultantOrderDetails
    }, {
      path: "/admin/inbound-delivery/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminInboundDeliveryDetails",
      component: AdminInboundDeliveryDetails
    }, {
      path: "/admin/orders/credit-notes/:id",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminEditCreditNote",
      component: AdminCreditNote
    }, {
      path: "/admin/contact/list",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminListContact",
      component: AdminListContact
    }, {
      path: "/admin/shipping",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminShipping",
      component: AdminShipping
    }, {
      path: "/admin/settings",
      meta: {
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminSettings",
      component: AdminSettings
    }, {
      path: "/admin/indicators",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminListIndicators",
      component: AdminListIndicators
    }, {
      path: "/admin/tasting-photos",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminTastingPhotos",
      component: AdminTastingPhotos
    }, {
      path: "/admin/tools",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "developerTools",
      component: DeveloperTools
    }, {
      path: "/admin/events",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminEventList",
      component: AdminEventList
    }, {
      path: "/admin/events/:id/details",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "adminEventDetails",
      component: AdminEventDetails
    },
    // CONSULTANT PAGES
    {
      path: "/consultant/commission/list",
      meta: {
        metaDatas: metaDatas,
        requireTokenExpiration: requireTokenExpiration
      },
      name: "consultantCommissionList",
      component: ConsultantCommissionList
    },
    //MAINTENANCE PAGES
    {
      path: "/maintenance",
      name: "maintenance",
      component: MaintenancePage
    },
    // OTHER PAGES
    {
      path: "*",
      component: Error,
      props: {
        error: {
          link: "userHome",
          linkTitle: "home"
        }
      }
    }]
  }]
};
var router = new Router(routes);
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var excludedRoutes;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          excludedRoutes = ["login", "start", "home"];
          if (excludedRoutes.includes(to.name)) {
            next();
          }
          if (router.app.$maintenanceMode.isActive && !hasRole(process.env.VUE_APP_ROLES_USE_DEVELOPER_TOOLS)) {
            if (to.name !== "maintenance") {
              next({
                name: "maintenance"
              });
            } else {
              next();
            }
          } else {
            if (to.name === "maintenance") {
              next({
                name: "login"
              });
            } else {
              next();
            }
          }
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.beforeEach(function (to, from, next) {
  //special pour wine-searcher.com
  var encodedPattern = /%[0-9A-Fa-f]{2}/;
  if (to.path.startsWith("/user/wine/") && encodedPattern.test(to.fullPath)) {
    var decodedPath = decodeURIComponent(to.fullPath);
    next(decodedPath);
  } else {
    next();
  }
});
router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requireTokenExpiration;
  })) {
    var token = jwt.decode(getRefreshToken());
    var valid = (token === null || token === void 0 ? void 0 : token.exp) > Math.floor(Date.now() / 1000);
    if (!valid) {
      var utm_source = to.query.utm_source;
      if (utm_source) {
        next({
          name: "login",
          query: {
            redirect: "".concat(to.path),
            utm_source: utm_source
          }
        });
      } else {
        next({
          name: "login",
          query: {
            redirect: "".concat(to.path)
          }
        });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});
router.beforeEach(handleNewsletter);
router.beforeEach(function (to, from, next) {
  if (from.path !== to.path) window.scrollTo(0, 0);
  next();
});
export default router;